/** @jsxImportSource @emotion/react */

import { FC } from 'react'
import FormControlLabel from '@mui/material/FormControlLabel'
import { Field, FieldProps, FieldRenderProps } from 'react-final-form'
import Chip from '@mui/material/Chip'
import FormHelperText from '@mui/material/FormHelperText'
import Autocomplete from '@mui/material/Autocomplete'
import TextField from '@mui/material/TextField'
import * as classes from './styles'

type Props = {
  label?: string
  placeholder?: string
  className?: string
} & FieldProps<string[], FieldRenderProps<string[], HTMLElement>>

export const FreeSoloAutocompleteField: FC<Props> = (props) => {
  const { controlLabelProps, label, placeholder, className, ...rest } = props

  return (
    <Field {...rest}>
      {({ input, meta }) => {
        const errorMessage = meta.error || meta.submitError

        return (
          <Autocomplete
            multiple
            options={[]}
            freeSolo
            className={className}
            renderValue={(value: readonly string[], getItemProps) =>
              value.map((option: string, index: number) => {
                const { key, ...tagProps } = getItemProps({ index })
                return <Chip variant="outlined" label={option} key={key} {...tagProps} />
              })
            }
            value={input.value}
            onChange={(_e, newValue) => {
              input.onChange(newValue)
            }}
            renderInput={(params) => (
              <>
                <FormControlLabel
                  label={label}
                  control={
                    controlLabelProps?.control || (
                      <TextField
                        {...params}
                        onBlur={input.onBlur}
                        onFocus={input.onFocus}
                        variant="outlined"
                        placeholder={placeholder}
                        error={Boolean(meta.touched && errorMessage)}
                      />
                    )
                  }
                  css={classes.freeSoloFormControlLabel}
                />
                {meta.touched && errorMessage && <FormHelperText error={errorMessage}>{errorMessage}</FormHelperText>}
              </>
            )}
          />
        )
      }}
    </Field>
  )
}
